// Warsaw metro stations (M1 + M2), name + centroid coords. Baked from
// flat.transit_stops (kind='metro') so the SERP area picker can suggest stations
// without a network call on the per-keystroke path (areaSearch is fully local).
// Powers "flats within ~X m of a station" proximity search.
export interface MetroStation {
  name: string;
  lat: number;
  lon: number;
}

export const WARSAW_METRO: MetroStation[] = [
  { name: 'Bemowo', lat: 52.23929, lon: 20.91502 },
  { name: 'Bródno', lat: 52.29356, lon: 21.02907 },
  { name: 'Centrum', lat: 52.231059, lon: 21.010188 },
  { name: 'Centrum Nauki Kopernik', lat: 52.239765, lon: 21.031448 },
  { name: 'Dworzec Gdański', lat: 52.257832, lon: 20.994385 },
  { name: 'Dworzec Wileński', lat: 52.254151, lon: 21.035401 },
  { name: 'Imielin', lat: 52.149136, lon: 21.046366 },
  { name: 'Kabaty', lat: 52.131983, lon: 21.065174 },
  { name: 'Kondratowicza', lat: 52.29208, lon: 21.05019 },
  { name: 'Księcia Janusza', lat: 52.239096, lon: 20.94411 },
  { name: 'Marymont', lat: 52.271663, lon: 20.971999 },
  { name: 'Młociny', lat: 52.29079, lon: 20.929819 },
  { name: 'Młynów', lat: 52.23764, lon: 20.960475 },
  { name: 'Natolin', lat: 52.141008, lon: 21.05651 },
  { name: 'Nowy Świat-Uniwersytet', lat: 52.236818, lon: 21.016803 },
  { name: 'Plac Wilsona', lat: 52.269339, lon: 20.984284 },
  { name: 'Płocka', lat: 52.2329, lon: 20.966178 },
  { name: 'Pole Mokotowskie', lat: 52.208484, lon: 21.007807 },
  { name: 'Politechnika', lat: 52.218421, lon: 21.015322 },
  { name: 'Racławicka', lat: 52.198908, lon: 21.012211 },
  { name: 'Ratusz Arsenał', lat: 52.244758, lon: 21.001369 },
  { name: 'Rondo Daszyńskiego', lat: 52.230014, lon: 20.982744 },
  { name: 'Rondo ONZ', lat: 52.233102, lon: 20.998285 },
  { name: 'Słodowiec', lat: 52.276787, lon: 20.960208 },
  { name: 'Służew', lat: 52.17253, lon: 21.026298 },
  { name: 'Stadion Narodowy', lat: 52.246965, lon: 21.042901 },
  { name: 'Stare Bielany', lat: 52.281792, lon: 20.949356 },
  { name: 'Stokłosy', lat: 52.155966, lon: 21.034865 },
  { name: 'Świętokrzyska', lat: 52.235586, lon: 21.008273 },
  { name: 'Szwedzka', lat: 52.263458, lon: 21.045309 },
  { name: 'Targówek Mieszkaniowy', lat: 52.269345, lon: 21.051378 },
  { name: 'Trocka', lat: 52.275266, lon: 21.055298 },
  { name: 'Ulrychów', lat: 52.24045, lon: 20.93001 },
  { name: 'Ursynów', lat: 52.161827, lon: 21.027693 },
  { name: 'Wawrzyszew', lat: 52.286318, lon: 20.939577 },
  { name: 'Wierzbno', lat: 52.189907, lon: 21.016599 },
  { name: 'Wilanowska', lat: 52.181869, lon: 21.022977 },
  { name: 'Zacisze', lat: 52.28426, lon: 21.06198 },
];
